import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChatSuggestionsService, type ChatSuggestionItem } from '@brighthub/copilot';
import { ASK_NAVI_AGENT_CONFIG } from '../../config/ask-navi-agent.config';

/**
 * Welcome screen for Ask Navi with avatar, tagline, and API-driven starter prompt grid.
 * Prompts are conversation starters only (auto-send on click); not shown during active threads.
 */
@Component({
  selector: 'an-ask-navi-welcome',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ask-navi-welcome.component.html',
  styleUrl: './ask-navi-welcome.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskNaviWelcomeComponent {
  private readonly _suggestions = inject(ChatSuggestionsService);
  private readonly _destroyRef = inject(DestroyRef);

  readonly prompts = signal<ChatSuggestionItem[]>([]);

  readonly promptSelect = output<string>();

  constructor() {
    this._suggestions
      .getSuggestions(ASK_NAVI_AGENT_CONFIG.agentId)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((items) => this.prompts.set(items));
  }

  onPromptClick(macro: string): void {
    this.promptSelect.emit(macro);
  }
}
